import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import WithdrawAddress from "./WithdrawAddress";
const WithdrawTab = ({ coin, hidemodal }) => {
  const [clickedDiv, setClickedDiv] = useState(coin[0]);

  const isDarkMode = useSelector((state) => state.theme.darkMode);

  return (
    <>
      <Container>
        <Row>
          <Col md={4} className="hr-withdraw">
            <div className="extra-cards-main">
              {coin?.map((item, index) => (
                <div
                  onClick={() => setClickedDiv(item)}
                  className={
                    isDarkMode
                      ? " cards-div-dark cards-div"
                      : "cards-div-light cards-div"
                  }
                >
                  <img src={item?.img} alt="" className="payment-card-img" />
                  <span>{item?.title} </span>
                </div>
              ))}
            </div>
          </Col>
          <Col md={8}>
            <WithdrawAddress item={clickedDiv} hidemodal={hidemodal} />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default WithdrawTab;
